export default class DataNotFoundError extends Error {
  private reason?: string;

  constructor(message = 'Data is not found!', reason?: string) {
    super(message);
    this.name = 'DataNotFoundError';
    this.reason = reason;
  }
}
